module.exports = __webpack_public_path__ + "static/mask_lo_114-cc369dab3487e3a59ecdb577644e24fc.jpg";